module.exports = __webpack_public_path__ + "img/c-human.47ccd787.svg";